import { render, staticRenderFns } from "./TourList.vue?vue&type=template&id=bae497e4&scoped=true"
import script from "./TourList.vue?vue&type=script&lang=js"
export * from "./TourList.vue?vue&type=script&lang=js"
import style0 from "./TourList.vue?vue&type=style&index=0&id=bae497e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae497e4",
  null
  
)

export default component.exports